import styled, { css } from 'styled-components';
import { gray10, gray20, gray90, gray95 } from '@spotify-internal/encore-foundation';

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.tableRow === 'dark';
};

export default styled.tr.withConfig({
  displayName: "TableRow",
  componentId: "lcijfk-0"
})(["border-bottom:1px solid ", ";", ";", ";"], function (props) {
  return isDarkTheme(props) ? gray20 : gray90;
}, function (props) {
  return props.hover && css(["&:hover{background-color:", ";border-bottom-color:", ";}"], isDarkTheme(props) ? gray20 : gray95, isDarkTheme(props) ? gray10 : gray90);
}, function (props) {
  return props.select && css(["background-color:", ";border-bottom-color:", ";"], isDarkTheme(props) ? gray20 : gray95, isDarkTheme(props) ? gray10 : gray90);
});